import React from 'react';

interface DetailSectionHeaderProps {
  icon: string
  title: string
}

const DetailSectionHeader = ({icon, title} : DetailSectionHeaderProps) => {
	return (
		<div className="property-details__section-header d-flex align-items-center">
			<i className={'fad ' + icon + ' me-2 cc-color--secondary mt-1'} />
			<h2 className="font--md cc-font-weight--bold mb-0 h4">{title}</h2>
		</div>
	);
};

export default DetailSectionHeader;
